import React from "react";
import { formatNumber } from "./charts/chartTheme";

/** The item written off as an expense (shown inside the expanded row of the expenses list). */
export default function ExpenseDetail({ row }) {
  const qty = Number(row.kolicina) || 0;
  return (
    <div className="flex items-baseline justify-between gap-3 text-sm">
      <span className="min-w-0 text-slate-800 dark:text-slate-100">
        {row.artikal || "Nepoznat artikal"}
        {qty > 0 && (
          <span className="ml-2 text-xs tabular-nums text-slate-500 dark:text-slate-400">× {formatNumber(qty, qty % 1 ? 3 : 0)}</span>
        )}
      </span>
      <span className="whitespace-nowrap font-medium tabular-nums text-slate-900 dark:text-slate-50">{formatNumber(row.vrednost, 2)}</span>
    </div>
  );
}
